import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { fetchHistorialConsumo, updateKilometrajeConsumo } from "../../services/Combustible/consumoService";
import { criterioHistorialConsumo } from "../../types/criterioHistorialConsumo";
import { ActualizaKilometraje } from "../../types/actualizaKilometraje";
//import { ConsumoCombustible } from "../../types/consumoCombustible";
import { HistorialConsumoCombustible as HistorialConsumoCombustibleResult } from "../../types/historialConsumoCombustible";
import { formatDateUtil } from '../../utils/fechaUtil';
import { formatNumber } from "../../utils/numberUtil";
import styles from '../../css/HistorialConsumo.module.css';
import { useAuth } from "../../context/AuthContext";


import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';
const saveAs = require("file-saver").saveAs


const HistorialConsumoCombustible: React.FC<criterioHistorialConsumo> = ({
    filtroPlaca = "",
    filtroFecha = "",
}) => {
    const { hasPermission, user } = useAuth();
    const [records, setRecords] = useState<HistorialConsumoCombustibleResult[]>([]);
    const [filtroLocalPlaca, setFiltroLocalPlaca] = useState<string>(filtroPlaca);
    const [filtroLocalFecha, setFiltroLocalFecha] = useState<string>(filtroFecha);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(15);
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [editingRecord, setEditingRecord] = useState<HistorialConsumoCombustibleResult | null>(null);
    const [newKilometraje, setNewKilometraje] = useState<number>(0);
    const [selectedRecord, setSelectedRecord] = useState<HistorialConsumoCombustibleResult | null>(null);


    // Cambiar la cantidad de elementos por página
    const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setPageSize(Number(e.target.value));  // Cambiar el tamaño de página
        setCurrentPage(1);  // Resetear a la primera página
    };

    const onSelectRecord = (record: HistorialConsumoCombustibleResult) => {
        setSelectedRecord(record);
    }

    const fetchConsumo = useCallback(
        async (page: number) => {
            try {
                const response = await fetchHistorialConsumo({
                    placa: filtroLocalPlaca,
                    fechaRegistro: filtroLocalFecha,
                    pageNumber: page,
                    pageSize,
                });
                console.log('Respuesta de historial: ', response)
                const historialConsumo: HistorialConsumoCombustibleResult[] = response.data.historialConsumo.map((item: any) => ({
                    consumoId: item.ConsumoID,
                    chofer: item.NO_EMPLE,
                    nombreChofer: item.NOMBRE,
                    placa: item.Placa,
                    numeroUnidad: item.NumeroUnidad,
                    centroCosto: item.CentroCosto,
                    centroCostoDesc: item.CentroCostoDesc,
                    kilometros: item.Kilometros,
                    horasUnidadFrio: item.HorasUnidadFrio,
                    cantidadLitros: item.CantidadLitros,
                    cantidadGalones: item.CantidadGalones,
                    fechaRegistro: item.FechaRegistro,
                    precioTotal: item.PrecioTotal,
                }))
                setRecords(historialConsumo);
                setTotalRecords(response.data.totalRecords);
                setTotalPages(Math.ceil(response.data.totalRecords / pageSize));

            } catch (error) {
                console.error("Error trayendo historial: ", error);
            }
        },
        [filtroLocalPlaca, filtroLocalFecha, pageSize]
    );

    useEffect(() => {
        fetchConsumo(currentPage);
    }, [fetchConsumo, currentPage, pageSize]);

    const handleFilterChange = () => {
        setCurrentPage(1);
        fetchConsumo(1);
    };

    const handleExportExcel = () => {
        try {
            const exportData = records.map((record) => ({
                //ID: record.consumoId,
                Placa: record.placa,
                NumeroUnidad: record.numeroUnidad,
                CentroCosto: record.centroCosto,
                CentroCostoDesc: record.centroCostoDesc,
                Chofer: record.chofer,
                NombreChofer: record.nombreChofer,
                Kilometraje: record.kilometros,
                HorasUnidadFrio: record.horasUnidadFrio,
                PrecioTotal: record.precioTotal,
                Litros: record.cantidadLitros,
                Galones: record.cantidadGalones,
                FechaRegistro: formatDateUtil(record.fechaRegistro)
            }));

            //Crea el worksheet a partir de los datos
            const worksheet = XLSX.utils.json_to_sheet(exportData);

            //Crear el workbook y añadir el worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "HistorialConsumo");

            //Convertir a buffer
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

            saveAs(dataBlob, "HistorialConsumo.xlsx");

        } catch (error) {
            console.error("Error al exportar a Excel:", error);
        }
    };

    const handleOpenEditModal = (record: HistorialConsumoCombustibleResult) => {
        setEditingRecord(record);
        setNewKilometraje(record.kilometros);
        setShowEditModal(true);
    };

    const handleSaveKilometraje = async () => {
        try {
            // Aquí irá la lógica para guardar en el backend
            console.log('Guardando nuevo kilometraje:', newKilometraje, 'para registro:', editingRecord?.consumoId);
            const response = await updateKilometrajeConsumo({
                consumoID: editingRecord?.consumoId || 0,
                kilometros: newKilometraje,
                user: user?.User.email || 'unknown'
            } as ActualizaKilometraje);

            Swal.fire({
                icon: 'success',
                title: 'Éxito',
                text: (response.data.message ? `: ${response.data.message}` : ''),
                timer: 2000,
                showConfirmButton: false,
            });

            // Cerrar modal después de guardar
            setShowEditModal(false);

            // Recargar datos
            fetchConsumo(currentPage);

        } catch (error) {
            console.error('Error al guardar kilometraje:', error);
        }
    };

    return (
        <div>
            <h5 className="mb-3 mt-2">Historial de Consumo de combustible</h5>
            <div className="d-flex mb-3 flex-wrap">
                <div className="row w-100">
                    <div className="col-12 col-md-3 mb-2">
                        <input
                            type="text"
                            placeholder="Digite placa"
                            className="form-control me-2"
                            value={filtroLocalPlaca}
                            onChange={(e) => setFiltroLocalPlaca(e.target.value)}
                        />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                        <input
                            type="date"
                            placeholder="Digite Fecha a consultar"
                            className="form-control me-2"
                            value={filtroLocalFecha}
                            onChange={(e) => setFiltroLocalFecha(e.target.value)}
                        />
                    </div>

                    {/* Desplegable para la cantidad de filas por página */}
                    <div className="col-12 col-md-2 mb-2">
                        {/* <label htmlFor="pageSize" className="me-2">Líneas:</label> */}
                        <select
                            title="Líneas por página"
                            id="pageSize"
                            className="form-select"
                            value={pageSize}
                            onChange={handlePageSizeChange}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={15}>15</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>
                    <div className="col-12 col-md-2 mb-2 d-flex align-items-end">
                        <button className="btn btn-primary w-100" onClick={handleFilterChange}>
                            Filtrar
                        </button>

                    </div>
                    <div className="col-12 col-md-2 mb-2 d-flex align-items-end">
                        <button
                            className="btn btn-success w-100"
                            onClick={handleExportExcel}
                        >
                            <i className="fas fa-file-excel me-2" />
                            Exportar a excel
                        </button>
                    </div>
                    {/*Botón para exportar a excel */}
                    {/* <div className="mt-3">
                        <button className="btn btn-success">
                            Exportar a excel
                        </button>
                    </div> */}
                </div>


            </div>
            <div className={styles.tableResponsive}>
                <table className="table table-striped table-hover table-sm table-responsive">
                    <thead>
                        <tr>
                            <th hidden>ID</th>
                            <th className="">Placa</th>
                            <th>Unidad</th>
                            <th>Centro Costo</th>
                            <th>Chofer</th>
                            <th>Nombre</th>
                            <th className="text-end">Precio</th>
                            <th className="text-end">Kilometraje</th>
                            <th className="text-nowrap text-end" title="Horas Unidad Frío">Horas U.F.</th>
                            <th className="text-end">Litros</th>
                            <th className="text-end">Galones</th>
                            <th className="text-center">Fecha Registro</th>
                            {hasPermission('Modificar Kilometraje') && (
                                <th className="text-center">Acciones</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((record, index) => (
                            <tr key={record.consumoId}
                                className={`${selectedRecord?.consumoId === record.consumoId ? 'border border-primary border-3': ''}`}
                                onClick={() => onSelectRecord(record)}
                            >
                                <td hidden>{record.consumoId}</td>
                                <td title={`Consumo ID: ${record.consumoId.toString()}`}>{record.placa}</td>
                                <td>{record.numeroUnidad}</td>
                                <td><small>{`${record.centroCosto} - ${record.centroCostoDesc}`}</small></td>
                                <td>{record.chofer}</td>
                                <td className="text-muted"><small>{record.nombreChofer}</small></td>
                                <td className="text-end">{formatNumber(record.precioTotal, 2)}</td>
                                <td className="text-end">{record.kilometros}</td>
                                <td className="text-end">{record.horasUnidadFrio}</td>
                                <td className="text-end">{record.cantidadLitros}</td>
                                <td className="text-end">{record.cantidadGalones}</td>
                                <td className="text-center">{formatDateUtil(record.fechaRegistro)}</td>
                                {hasPermission('Modificar Kilometraje') && (
                                    <td className="text-center">
                                        <button
                                            className="btn btn-sm btn-primary"
                                            title="Modificar Kilometraje"
                                            onClick={() => handleOpenEditModal(record)}
                                        >
                                            <i className="fas fa-edit" />
                                        </button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="d-flex justify-content-between">
                <button
                    className="btn btn-secondary"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                >
                    Anterior
                </button>
                <span>Página {currentPage} de {totalPages} <strong> Registros Totales ( {totalRecords} ) </strong></span>
                <button
                    className="btn btn-secondary"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                >
                    Siguiente
                </button>
            </div>
            {showEditModal && editingRecord && (
                <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Modificar Kilometraje: ({editingRecord.consumoId})</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowEditModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">
                                        <strong>Placa:</strong> {editingRecord.placa}
                                    </label>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">
                                        <strong>Fecha:</strong> {formatDateUtil(editingRecord.fechaRegistro)}
                                    </label>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">
                                        <strong>Kilometraje Actual:</strong> {editingRecord.kilometros}
                                    </label>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="kilometraje" className="form-label">
                                        <strong>Nuevo Kilometraje</strong>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="kilometraje"
                                        value={newKilometraje}
                                        onChange={(e) => setNewKilometraje(Number(e.target.value))}
                                        min="0"
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowEditModal(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSaveKilometraje}
                                >
                                    Guardar Cambios
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HistorialConsumoCombustible;